import React from 'react';
import classnames from 'classnames';
import { Icon, Button, ButtonGroup, Card } from 'ui';

const QuestionPanel = ({
  scenario,
  children,
  saveAttemptWithFeedback,
  saveAttempt,
  saving,
  answer,
  isComplete,
}) => {
  const showAskForFeedback = scenario.canRequestFeedback;
  return (
    <Card className="OnDemandPracticeQuestion">
      <Card.Content padding="large">
        <h1 className="OnDemandPracticeQuestion-title">
          <Icon name="rocket" className="is-28 mr-8" />{' '}
          {t('practice.practice_feedback.practice_title')}
        </h1>
        <div className="OnDemandPracticeQuestion-content">
          <div className="OnDemandPracticeQuestion-metadata">
            <header>
              <h1 className="OnDemandPracticeQuestion-prompt text-wrap">
                {scenario.prompt}
              </h1>
              <p>
                {t(
                  `practice.on_demand_practice.${scenario.scenarioType}.instructions`,
                )}
              </p>
            </header>
          </div>
          <div className="OnDemandPracticeQuestion-question">
            {children}
            <div
              className={classnames('OnDemandPracticeQuestion-feedback', {
                disabled: !isComplete || !answer,
              })}
            >
              {!showAskForFeedback && (
                <>
                  <h1 className="OnDemandPracticeQuestion-feedbackTitle">
                    <Icon name="high_five" className="is-28 mr-8" />
                    {t('practice.practice_feedback.feedback_title')}
                  </h1>
                  <p className="m-16">
                    <strong>
                      {t('practice.on_demand_practice.completed_text')}
                    </strong>
                  </p>
                  <ButtonGroup alignEnd>
                    <Button
                      disabled={saving}
                      onClick={saveAttempt}
                      className="mb-16"
                    >
                      {t('practice.on_demand_practice.save_attempt')}
                    </Button>
                  </ButtonGroup>
                </>
              )}
              {showAskForFeedback && (
                <>
                  <h1 className="OnDemandPracticeQuestion-feedbackTitle">
                    <Icon name="high_five" className="is-28 mr-8" />
                    {t('practice.practice_feedback.feedback_title')}
                  </h1>
                  <p className="m-16">
                    <strong>
                      {t('practice.practice_feedback.completed_text')}
                    </strong>
                  </p>
                  <div className="d-f m-fd-c jc-sb w-fill mt-16">
                    <div className="ta-c OnDemandPracticeQuestion-nextStepsLeft">
                      <Button
                        customColor
                        disabled={saving}
                        onClick={saveAttemptWithFeedback}
                        className="mb-16 w-fill"
                      >
                        {t('practice.practice_feedback.save_and_ask')}
                      </Button>
                      <p>
                        <em>
                          {t('practice.practice_feedback.save_and_ask_text')}
                        </em>
                      </p>
                    </div>
                    <div className="OnDemandPracticeQuestion-nextStepsOr ta-c tt-u fw-b fz-16">
                      {t('common.or')}
                    </div>
                    <div className="ta-c OnDemandPracticeQuestion-nextStepsRight">
                      <Button
                        disabled={saving}
                        onClick={saveAttempt}
                        className="mb-16 w-fill"
                      >
                        {t('practice.practice_feedback.save')}
                      </Button>
                      <p>
                        <em>{t('practice.practice_feedback.save_text')}</em>
                      </p>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </Card.Content>
    </Card>
  );
};

export default QuestionPanel;
